import { useEffect, useState } from "react";
import styles from "./City.module.css";
import mainStyles from "../Main.module.css";
import { Button, TextField } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

import loadingImage from "../loading.gif";
import api from "../../services/api";
import { useDispatch } from "react-redux";
import { addCity } from "../../State/City/Action";
import { getStates } from "../../State/State/Action";

export default function City() {
  const [cityName, setCityName] = useState("");
  const [cityDescription, setCityDescription] = useState("");
  const [isSaved, setIsSaved] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const [states, setStates] = useState([]);
  const [stateId, setStateId] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    api
      .get("/states")
      .then((res) => {
        setIsLoading(false);
        setStates(res.data);
      })
      .catch((error) => {
        onFailedSave();
      });
  }, []);

  const onSuccessfulSave = () => {
    setIsSaved(true);
    setIsLoading(false);
    setHasError(false);
  };

  const onFailedSave = () => {
    setIsLoading(false);
    setIsSaved(false);
    setHasError(true);
  };

  const resetForm = () => {
    setCityName("");
    setCityDescription("");
    setStateId("");
  };

  const validateForm = () => {
    if (cityName === "" || stateId === "") {
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (validateForm()) {
      const city = { 
        cityName, 
        cityDescription, 
        stateId 
      };

      try {
        await dispatch(addCity(city));
        onSuccessfulSave();
        resetForm();
      } catch (error) {
        onFailedSave();
      }
    } else {
      onFailedSave();
    }
  };

  return isLoading ? (
    <div className={mainStyles.loadingContainer}>
      <img src={loadingImage} alt="loading" />
    </div>
  ) : (
    <div>
      <form onSubmit={handleSubmit}>
        <header className={mainStyles.header}>Add City</header>
        <div className="text-center">
          <select
            className="border border-gray-300 rounded-md p-2 "
            onChange={(e) => setStateId(e.target.value)}
            value={stateId}
          >
            <option value=""> Select State </option>
            {states.map((state) => (
              <option key={state.stateId} value={state.stateId}>
                {state.stateName}
              </option>
            ))}
          </select>
        </div>
        <div className={styles.componentContainer}>
          <TextField
            className={styles.component}
            variant="standard"
            onChange={(e) => setCityName(e.target.value)}
            value={cityName}
            label="Enter City Name"
          />
        </div>
        <div className={styles.componentContainer}>
          <TextField
            className={styles.component}
            onChange={(e) => setCityDescription(e.target.value)}
            value={cityDescription}
            label="Enter City Description"
            multiline
            rows={3}
          />
        </div>
        <div className={styles.componentContainer}>
          <Button
            className={styles.saveBtn}
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
          >
            {" "}
            Save City
          </Button>
        </div>
        <div className={styles.componentContainer}>
          {isSaved && (
            <div>
              <p className={mainStyles.success}>
                City Saved Successfully
              </p>
            </div>
          )}
          {hasError && (
            <div>
              <p className={mainStyles.error}>
                Some error occurred while saving.{" "}
              </p>
            </div>
          )}
        </div>
      </form>
    </div>
  );
}

